import { useContext } from 'react'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from './TextButton'
import ContactContext from 'contexts/contactContext'

interface Props {
  currentContact?: App.GeoContact
  onClick?: () => void
}

function SupportNumberButton({ currentContact, onClick }: Props) {
  const geoContact = useContext(ContactContext)
  const contact = currentContact ?? geoContact.defaultContact

  return <TextButton
    onClick={() => onClick?.()}
    kind="secondary"
    variant="default"
    startIcon={<LinePhoneIcon />}
    href={`tel:${contact.number}`}
    rel="nofollow"
    fit="flex"
  >
    {contact.humanReadable}
  </TextButton>
}

export default SupportNumberButton
